module.exports = __webpack_public_path__ + "img/ezhou-airport.d87a214.webp";